import { IconNames } from '@blueprintjs/icons';
import { skipToken } from '@reduxjs/toolkit/query';
import { IconButton } from '@strata/react-buttons';
import { InlineMessage } from '@strata/react-inline-message';
import { ExpandedRowDetailsSection } from '@strata/react-label-value-pairs';
import PropTypes from 'prop-types';

import {
    getClaimDetailSections,
    getTestClaimConsequence,
} from 'components/treatments/claimInsightsFields';
import { useGetPrescriberDetailsQuery, useGetSupplierDetailsQuery } from 'store/api/referenceApi';

export const ClaimInsightsDetailPanel = ({ title, claim, onClose }) => {
    const { data: assignedSupplier } = useGetSupplierDetailsQuery(
        !claim.isTestClaim && claim.assignedSupplierNpi
            ? { supplierNpi: claim.assignedSupplierNpi }
            : skipToken,
    );
    const { data: billingSupplier } = useGetSupplierDetailsQuery(
        claim.billingSupplierNpi ? { supplierNpi: claim.billingSupplierNpi } : skipToken,
    );
    const { data: prescriberDetails } = useGetPrescriberDetailsQuery(
        claim.prescriberNpi ? { prescriberNpi: claim.prescriberNpi } : skipToken,
    );

    const consequence = claim.isTestClaim ? getTestClaimConsequence(claim) : null;
    const sections = getClaimDetailSections(claim, {
        assignedSupplierName: assignedSupplier?.organizationName,
        billingSupplierName: billingSupplier?.organizationName,
        prescriberName: prescriberDetails?.prescriberName,
    });

    return (
        <div>
            <div
                className="flex__gap--small margin__bottom--medium"
                style={{ alignItems: 'center', justifyContent: 'space-between' }}
            >
                <div className="font-semi-bold">{title}</div>
                <IconButton icon={IconNames.CROSS} title="Close detail" onClick={onClose} />
            </div>
            {consequence && (
                <div className="margin__bottom--medium">
                    <InlineMessage intent={consequence.intent} wrapText label={consequence.label} />
                </div>
            )}
            <ExpandedRowDetailsSection sections={sections} />
        </div>
    );
};

ClaimInsightsDetailPanel.propTypes = {
    title: PropTypes.string.isRequired,
    claim: PropTypes.shape({
        isTestClaim: PropTypes.bool,
        assignedSupplierNpi: PropTypes.string,
        billingSupplierNpi: PropTypes.string,
        prescriberNpi: PropTypes.string,
    }).isRequired,
    onClose: PropTypes.func.isRequired,
};
